import { render, staticRenderFns } from "./ErrorAuth.vue?vue&type=template&id=281cced8&scoped=true&lang=pug&"
import script from "./ErrorAuth.vue?vue&type=script&lang=ts&"
export * from "./ErrorAuth.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorAuth.vue?vue&type=style&index=0&id=281cced8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281cced8",
  null
  
)

export default component.exports